module.exports = __webpack_public_path__ + "img/watermelon.a32e1896.svg";